import styled from "styled-components";

const Container = styled.div`
  z-index: auto;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 33%;
  left: 33%;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  padding: 25px;
  width: 700px;
`;

const ContentContainer = styled.div`
width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 45px;
  > * {
    &:last-child{
      margin-left: 16px;
    }
  }
`;

const Label = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
`
export { Container, ContentContainer, ButtonContainer, Label };
